import {
  firebaseConfig,
  STORAGE_EMULATOR_HOST,
} from 'features/firebase/firebaseConfig';

const STORAGE_ORIGIN =
  import.meta.env.MODE === 'development'
    ? `http://${STORAGE_EMULATOR_HOST}`
    : 'https://firebasestorage.googleapis.com';

/** The public download URL of an object in the app's Storage bucket; the
 *  Storage emulator's in development. */
export const storageObjectUrl = (path: string): string =>
  `${STORAGE_ORIGIN}/v0/b/${firebaseConfig.storageBucket ?? ''}/o/${encodeURIComponent(path)}?alt=media`;
